<template>
  <div class="nx-form" v-if="file">
    <h2 class="nx-form-legend mb-1 mt-2" v-html="heading" v-if="title"></h2>
    <div class="nx-form-fieldset">
      <nx-file-upload-list-item
        :file="file"
        @click="handleClick"
        :isFileCompleted="isFileCompleted">
      </nx-file-upload-list-item>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NxFileUploadListItem from './FileUploadListItem';

export default {
  name: 'nx-file-upload-content-progress-bar',
  components: {
    NxFileUploadListItem,
  },
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    title: String,
  },
  computed: {
    ...mapGetters('upload', [
      'allFiles',
      'processingFilesCount',
    ]),
    file() {
      return this.allFiles.find(file => file.contentId === this.$getParentEditor().id) || null;
    },
    isFileCompleted() {
      if (!this.file) {
        return false;
      }
      return this.file.progress === 100;
    },
    heading() {
      if (this.$te(`message.form.scopes.${this.title}`)) {
        return this.$t(`message.form.scopes.${this.title}`);
      }
      return this.title;
    },
  },
  methods: {
    handleClick() {
      // Do nothing
    },
  },
};
</script>
